import type { GateType } from '../circuit/SignalState';

const gates: GateType[] = ['AND', 'NAND', 'OR'];
const inputs: Array<[0|1, 0|1]> = [[0,0],[0,1],[1,0],[1,1]];

export class AutoDemoController {
  private gateIndex = 0;
  private inputIndex = 0;
  private elapsed = 0;
  private running = false;
  private paused = false;

  constructor(private apply: (gate: GateType, a: 0|1, b: 0|1, text: string) => void, private finish: () => void) {}

  start(): void {
    this.gateIndex = 0;
    this.inputIndex = 0;
    this.elapsed = 0;
    this.running = true;
    this.paused = false;
    this.show();
  }

  togglePause(): boolean {
    if (!this.running) return false;
    this.paused = !this.paused;
    return this.paused;
  }

  reset(): void {
    this.running = false;
    this.paused = false;
    this.elapsed = 0;
    this.finish();
  }

  update(delta: number): void {
    if (!this.running || this.paused) return;
    this.elapsed += delta;
    if (this.elapsed < 2.4) return;
    this.elapsed = 0;
    this.inputIndex++;
    if (this.inputIndex >= inputs.length) {
      this.inputIndex = 0;
      this.gateIndex++;
    }
    if (this.gateIndex >= gates.length) {
      this.running = false;
      this.finish();
      return;
    }
    this.show();
  }

  private show(): void {
    const gate = gates[this.gateIndex];
    const [a, b] = inputs[this.inputIndex];
    this.apply(gate, a, b, `${gate}：输入 A=${a}、B=${b}。观察 Y 与 LED（LED 在 Y=0 时亮）。`);
  }
}
